import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanDeactivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Location } from '@angular/common';
import { IWGSharedService } from '../../shared/services/shared.service';

export interface CanComponentDeactivate {
    canDeactivate: () => Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree;
}

@Injectable({
    providedIn: 'root'
})

export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {
    constructor(private locationService: Location,
        private router: Router, private sharedService: IWGSharedService,) { }
    canDeactivate(component: CanComponentDeactivate,
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot) {
        if (component.canDeactivate) {
            component.canDeactivate()
        }
        if (this.sharedService.getAssignmentQuestionDirty()) {
            let res = confirm('Are you sure you want to leave the page without submitting?');
            if (res == true) {
                this.sharedService.setAssignmentQuestionDirty(false);
                return true;
            }
            else {
                const currentUrlTree = this.router.createUrlTree([], route);
                const currentUrl = currentUrlTree.toString();
                var herf = window.location.href;
                var origin = window.location.origin;
                var newPath = herf.replace(origin, "");
                if (newPath !== currentUrl) {
                    this.locationService.go(currentUrl);
                }

                return false;
           }
        }else{
            return true;
        }
    }


}